import { styled } from "@mui/material";
import { Menu } from "../Menu";

export const StyledMenu = styled(Menu, {
  shouldForwardProp: (prop) =>
    prop !== "minWidth" &&
    prop !== "marginTop" &&
    prop !== "maxWidth" &&
    prop !== "maxHeight",
})<{
  minWidth?: string;
  marginTop?: string;
  maxWidth?: string;
  maxHeight?: string;
}>`
  & .MuiPaper-root {
    min-width: ${({ minWidth }) => minWidth || "17rem"};
    padding-bottom: ${({ theme }) => theme.wsc.spacing[1]};
    margin-top: ${({ marginTop }) => marginTop || "0"};
    max-width: ${({ maxWidth }) => maxWidth || "none"};
    overflow: hidden;

    & .MuiList-root {
      max-height: ${({ maxHeight }) => maxHeight || "none"};
      gap: 0;
      padding: 0;
    }
  }
`;

export const StyledSearchWrapper = styled("div")`
  padding: ${({ theme }) => theme.wsc.spacing[1]};
  &:focus {
    outline: none;
  }
  /* Ensure this wrapper doesn't trap focus */
  &[tabindex] {
    outline: none;
  }
`;

export const StyledMenuItemContentWrapper = styled("div")`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.wsc.spacing[1]};
  &:focus {
    outline: none;
  }
`;

export const StyledMenuList = styled("div")<{ maxHeight?: string }>`
  max-height: ${({ maxHeight }) => maxHeight};
  overflow: hidden auto;
  display: flex;
  flex-direction: column;
  &:focus {
    outline: none;
  }
  /* Ensure this wrapper doesn't trap focus */
  &[tabindex] {
    outline: none;
  }
`;
